import React, { createContext, useContext, useEffect, useState } from 'react'
import { gTranslateBatch } from '@/api/gtranslate'
import { base } from '@/settings/base'

const TCtx = createContext()
export const useT = () => useContext(TCtx)

export function TranslateProvider({ children }) {
  const [lang, setLang]   = useState(localStorage.getItem('lang') || 'en')
  const [dict, setDict]   = useState(() => JSON.parse(localStorage.getItem('websuperadmin_dict') || '{}') || { en: base })
  const [ready, setReady] = useState(lang === 'en')

  useEffect(() => {
    ;(async () => {
      if (lang === 'en') { setReady(true); return }
      setReady(false)
      const missing = Object.keys(base).filter(k => !(dict[lang]?.[k]))
      if (!missing.length) { setReady(true); return }

      try {
        const { translations } = await gTranslateBatch(missing.map(k => base[k]), lang)
        const langDict = { ...(dict[lang] || {}) }
        missing.forEach((k, i) => { langDict[k] = translations[i] || base[k] })
        const updated = { ...dict, [lang]: langDict }
        setDict(updated)
        localStorage.setItem('websuperadmin_dict', JSON.stringify(updated))
      } catch {
        /* ignore */
      } finally {
        setReady(true)
      }
      document.documentElement.classList.forEach(c => c.startsWith('lang-') && document.documentElement.classList.remove(c))
      document.documentElement.classList.add(`lang-${lang}`)
    })()
  }, [lang])

  const t = k => dict[lang]?.[k] || base[k] || k
  const changeLang = c => { if (c && c !== lang) { setLang(c); localStorage.setItem('lang', c) } }

  return <TCtx.Provider value={{ t, lang, changeLang, ready }}>{children}</TCtx.Provider>
}
